import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f96fecfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-fullwidth" }
const _hoisted_2 = ["onUpdate:modelValue"]
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = { class: "is-narrow" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-plus" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.KVPairs, (item, i) => {
        return (_openBlock(), _createElementBlock("tr", { key: i }, [
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              "onUpdate:modelValue": ($event: any) => ((item.key) = $event),
              placeholder: "key",
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.updatedDict)))
            }, null, 40, _hoisted_2), [
              [_vModelText, item.key]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
              placeholder: "value",
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.updatedDict)))
            }, null, 40, _hoisted_3), [
              [_vModelText, item.value]
            ])
          ]),
          _createElementVNode("td", _hoisted_4, [
            (i === _ctx.KVPairs.length - 1)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "button is-primary",
                  title: "Add another row",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)))
                }, _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}